import React from 'react';
import { UnlimThreeStatus } from '@beef/elk-common/constants';
import { ReplenishmentButton, UnlimitedAccumulatorButton, getUnlimitedAccumulatorButtonClickHandler } from '@beef/elk-common';
import { useIsDesktopDimension } from '@carnica/utils/hooks';
import { Metric, fubMetricSideMenu } from "../../../utils/metric";
export var AddAccumButton = function AddAccumButton(_ref) {
  var _services$unlimited, _services$unlimited2;
  var accumulator = _ref.accumulator,
    unlimitedButtonType = _ref.unlimitedButtonType,
    onClick = _ref.onClick,
    services = _ref.services,
    userType = _ref.userType,
    isSvyazZ = _ref.isSvyazZ,
    tariffUrl = _ref.tariffUrl;
  var isDesktop = useIsDesktopDimension();
  var isUnlimitedButtonEnabled = accumulator.isUnlimited || ((services === null || services === void 0 || (_services$unlimited = services.unlimited3) === null || _services$unlimited === void 0 ? void 0 : _services$unlimited.status) === UnlimThreeStatus.COOLING || (services === null || services === void 0 || (_services$unlimited2 = services.unlimited3) === null || _services$unlimited2 === void 0 ? void 0 : _services$unlimited2.status) === UnlimThreeStatus.AVAILABLE) && !(accumulator !== null && accumulator !== void 0 && accumulator.replenishButtonType) && (accumulator === null || accumulator === void 0 ? void 0 : accumulator.socType) === 'PricePlan';
  return isUnlimitedButtonEnabled ? /*#__PURE__*/React.createElement(UnlimitedAccumulatorButton, {
    buttonType: unlimitedButtonType,
    handleAddClick: getUnlimitedAccumulatorButtonClickHandler({
      accumulatorButtonType: unlimitedButtonType,
      isSvyazZ: isSvyazZ,
      replenishButtonType: accumulator.replenishButtonType,
      tariffUrl: tariffUrl,
      isDesktop: isDesktop,
      onClick: onClick
    }),
    sendClickMetric: function sendClickMetric(data) {
      return fubMetricSideMenu.handleUnlimAccumulatorClick(data);
    },
    shouldRender: !!unlimitedButtonType,
    userType: userType,
    "data-t-id": "Container-AddAccumButton"
  }) : /*#__PURE__*/React.createElement(Metric, {
    data: userType,
    events: {
      fubMetricSideMenu: ['handleAddTrafficClick']
    },
    mode: "click"
  }, /*#__PURE__*/React.createElement(ReplenishmentButton, {
    isSvyazZ: isSvyazZ,
    replenishButtonType: accumulator.replenishButtonType,
    shouldRender: !!accumulator.replenishButtonType,
    tariffUrl: tariffUrl,
    "data-t-id": "Container-AddAccumButton"
  }));
};